export default "__VITE_ASSET__BO$zSKMl__"